module.exports = __webpack_public_path__ + "img/social-media-discussion.4040052a.svg";